/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sidebar_Preview_Chat_1Inputs */



/**
* | output |
* | --- |
* | "Mirko's Q3 marketing plan" |
*
* @param {Sidebar_Preview_Chat_1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sidebar_preview_chat_1 = /** @type {((inputs?: Sidebar_Preview_Chat_1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sidebar_Preview_Chat_1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Mirkos Marketingplan Q3")
	return /** @type {LocalizedString} */ ("Mirko's Q3 marketing plan")
});